import { useReadbackStore } from '../state/readbackStore'

/// Floating quoted-red transcript at top-center. Each line is a
/// pretend-radio readback ("FOA101, descend and maintain 5,000")
/// that auto-fades after the store's TTL. Pointer-events-none so
/// the stack never blocks clicks on the radar underneath.
export function ReadbackToasts() {
  const messages = useReadbackStore((s) => s.messages)
  if (messages.length === 0) return null
  return (
    <div className="pointer-events-none absolute left-1/2 top-3 z-30 flex w-[520px] max-w-[calc(100vw-2rem)] -translate-x-1/2 flex-col gap-1">
      {messages.map((m) => (
        <div
          key={m.id}
          className="rounded bg-black/55 px-3 py-1 text-center text-sm font-medium text-rose-400 shadow ring-1 ring-rose-500/30 backdrop-blur"
        >
          &ldquo;{m.text}&rdquo;
        </div>
      ))}
    </div>
  )
}
